"use client";

import { cn } from "@/lib/utils";
import useDataStore from "@/stores/data-store";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

export default function ButtonCollapsed({ className }: { className?: string }) {
  const {
    isSidebarCollapsed,
    isSidebarOpen,
    toggleSidebarCollapsed,
    toggleSidebarOpen,
  } = useDataStore();

  const buttonClassName = cn(
    "items-center justify-center rounded-lg border border-white/12 bg-white/[0.07] text-white/90 transition hover:bg-white/[0.12] hover:text-white active:scale-[0.98]",
    "size-9",
    className
  );

  return (
    <>
      <button
        type="button"
        aria-label="Open sidebar"
        className={cn("inline-flex lg:hidden", buttonClassName)}
        onClick={toggleSidebarOpen}
      >
        {isSidebarOpen ? (
          <PanelLeftClose className="size-4.5" />
        ) : (
          <PanelLeftOpen className="size-4.5" />
        )}
      </button>

      <button
        type="button"
        aria-label="Collapse sidebar"
        className={cn("hidden lg:inline-flex", buttonClassName)}
        onClick={toggleSidebarCollapsed}
      >
        {isSidebarCollapsed ? (
          <PanelLeftOpen className="size-4.5" />
        ) : (
          <PanelLeftClose className="size-4.5" />
        )}
      </button>
    </>
  );
}
